// extracted by mini-css-extract-plugin
export default {"avatar":"E39nijU2epojGizs6E8y","icon_container":"vkwIBMHP95RKBlvx0XUk","sm":"B9Vwa3JdA8fSznSof2re","md":"AAbGRpPY4n0WTtF4Iw_A","lg":"URt4EGlWm8upuZ9TOZyD"};